export const home = {
  // Hero
  hero_eyebrow: 'INDEPENDENT GUIDE \u2022 UPDATED 2026',
  hero_h1: 'CSSBuy Spreadsheet: Find Products, Links & CSSBuy Guides',
  hero_description: 'Explore an independent CSSBuy Spreadsheet guide with organized products, categories, QC information, shipping, reviews, comparisons and practical tips for buyers.',
  hero_cta_primary: 'Explore CSSBuy Spreadsheet',
  hero_cta_secondary: 'View CSSBuy Guides',
  hero_trust: 'Independent information \u2022 Practical guides \u2022 Organized content',

  // Categories
  categories_title: 'Popular CSSBuy Spreadsheet Categories',
  categories_cta: 'View products',
  cat_shoes: 'Shoes',
  cat_hoodies: 'Hoodies/Sweaters',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jackets',
  cat_pants: 'Pants/Shorts',
  cat_headwear: 'Headwear',
  cat_sets: 'Sets',
  cat_underwear: 'Underwear',
  cat_jersey: 'Jersey',
  cat_accessories: 'Accessories',
  cat_bags: 'Bags',
  cat_belts: 'Belts',
  cat_perfumes: 'Perfumes',
  cat_other: 'Other Stuff',

  // What is
  whatis_title: 'What is the CSSBuy Spreadsheet?',
  whatis_text: 'The CSSBuy Spreadsheet is an organized way to discover and compare products, links, and resources related to CSSBuy. Instead of searching for scattered information across different pages, you can explore categories, consult QC guides, and find useful information about shipping and buying in one place.',
  whatis_cta: 'Explore the Spreadsheet',

  // How it works
  howitworks_title: 'How to Use the CSSBuy Spreadsheet',
  step1_title: 'Search',
  step1_desc: 'Find a category or product.',
  step2_title: 'Compare',
  step2_desc: 'Compare available information and links.',
  step3_title: 'Verify',
  step3_desc: 'Check seller, price, options, and QC.',
  step4_title: 'Decide',
  step4_desc: 'Do your own verification before buying.',

  // Guides
  guides_title: 'Most Popular CSSBuy Guides',
  guide_review: 'CSSBuy Review',
  guide_shipping: 'CSSBuy Shipping Cost',
  guide_warehouse: 'CSSBuy Warehouse',
  guide_qc: 'CSSBuy QC',
  guide_coupon: 'CSSBuy Coupon',
  guide_legit: 'CSSBuy Legit',

  // Safety
  safety_title: 'CSSBuy Safety Center',
  safety_notice: 'IMPORTANT SAFETY NOTICE',
  safety_disclaimer: 'This is an independent informational website. It is not the official CSSBuy website. We do not process payments, orders, refunds or shipping.',
  safety_verify_urls: 'Verify URLs',
  safety_verify_sellers: 'Verify Sellers',
  safety_verify_price: 'Check Current Price',
  safety_verify_qc: 'Check QC',
  safety_verify_shipping: 'Check Shipping',
  safety_payments: 'Avoid Suspicious Payments',
  safety_passwords: 'Never Share Passwords',
  safety_customs: 'Check Customs Rules',
  safety_small_orders: 'Start with Small Orders',

  // Featured
  featured_title: 'Featured CSSBuy Spreadsheet',
  featured_product: 'Product',
  featured_category: 'Category',
  featured_platform: 'Platform',
  featured_seller: 'Seller',
  featured_qc: 'QC',
  featured_updated: 'Updated',
  featured_action: 'Action',
  featured_verify: 'Verify current information',
  featured_cta: 'View all products',

  // FAQ
  faq_title: 'Frequently Asked Questions',
  faq_q1: 'What is CSSBuy Spreadsheet?',
  faq_a1: 'CSSBuy Spreadsheet is an organized guide to resources, products, and links related to CSSBuy.',
  faq_q2: 'How does CSSBuy Spreadsheet work?',
  faq_a2: 'You navigate categories, find products and links, and consult buying guides.',
  faq_q3: 'Is CSSBuy Spreadsheet free?',
  faq_a3: 'Yes, this is a free independent informational resource.',
  faq_q4: 'How do I check a CSSBuy product?',
  faq_a4: 'Consult QC guides and verify sellers before buying.',
  faq_q5: 'Is CSSBuy legit?',
  faq_a5: 'CSSBuy is a known platform. Always verify sellers and links before buying.',
  faq_q6: 'How does CSSBuy shipping work?',
  faq_a6: 'Shipping depends on weight, volume, destination, and chosen shipping line.',
  faq_q7: 'How does CSSBuy QC work?',
  faq_a7: 'QC means Quality Control. It is the process of verifying products before shipping.',
  faq_q8: 'How much does CSSBuy shipping cost?',
  faq_a8: 'Cost depends on various factors. Verify current information on the official website.',

  // Final CTA
  final_cta_title: 'Explore the CSSBuy Spreadsheet and find organized guides and resources for your research.',
  final_cta_button: 'Explore CSSBuy Spreadsheet',

  // Buttons
  btn_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',
  btn_buy_it_now: 'Buy It Now',

  // Footer
  footer_tagline: 'Independent informational resource. Not affiliated with or endorsed by CSSBuy.',
  footer_links: 'Links',
  footer_legal: 'Legal',
  footer_spreadsheet: 'CSSBuy Spreadsheet',
  footer_guides: 'Guides',
  footer_reviews: 'Reviews',
  footer_shipping: 'Shipping',
  footer_coupon: 'Coupons',
  footer_warehouse: 'Warehouse',
  footer_qc: 'QC',
  footer_safety: 'Safety',
  footer_comparison: 'Comparison',
  footer_faq: 'FAQ',
  footer_about: 'About',
  footer_contact: 'Contact',
  footer_privacy: 'Privacy',
  footer_terms: 'Terms',
  footer_disclaimer: 'Disclaimer',
  footer_languages: 'Languages',
  footer_lang_pt: 'Portugu\u00eas',
  footer_lang_de: 'Deutsch',
  footer_lang_en: 'English',

  // Nav
  nav_spreadsheet: 'Spreadsheet',
  nav_categories: 'Categories',
  nav_guides: 'Guides',
  nav_reviews: 'Reviews',
  nav_shipping: 'Shipping',
  nav_safety: 'Safety',
  nav_language: 'Language',
  nav_home: 'Home',
  nav_shopping_guide: 'Shopping Guide',
  mobile_categories_title: 'Categories',
  pillar_title: 'CSSBuy Spreadsheet Pillar Guides',

  // Search
  search_placeholder: 'Search in CSSBuy Spreadsheet...',
  search_filter_category: 'Category',
  search_filter_platform: 'Platform',
  search_filter_product: 'Product',
  search_filter_seller: 'Seller',
  search_filter_qc: 'QC',
  search_filter_updated: 'Updated',
  search_btn: 'Search',
  search_find_fast: 'Find what you are looking for quickly',

  // Disclaimer
  independent_notice: 'Independent informational resource. Not the official CSSBuy website.',
};